import styled from "styled-components";

export const ConnectWalletModalStyle = styled.div`
    position: fixed;
    left: 0;
    width: 100vw;
    top: 0;
    height: 100vh;
    z-index: 888;
    background: rgb(13,13,13,0.7);
    .connectWalletContent{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 344px;
        border-radius: 8px;
        background: #fff;
        padding: 32px;
        box-sizing: border-box;
        color: #000;
    }
`;
export const StepBox = styled.div`

`;

export const Explain = styled.div`

`;

export const Title = styled.h3`

`;

export const Subtitle = styled.div`

`;

export const Process = styled.div`

`;

export const ConnectButton = styled.button`
    width: 100%;
    height: 40px;
    margin-top: 28px;
    background: transparent;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 12px;
    font-weight: bold;
    color: #000;
`;


export const WalletList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
`;
export const NetworkBox = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8px;
`;
export const NetworkItem = styled.div`
    display: flex;
    align-items: center;
    min-width: 120px;
    height: 50px;
    padding: 8px;
    border-radius: 8px;
    background: #fff;
    color: #000;
    font-size: 12px;
    font-weight: 700;
    box-sizing: border-box;
    cursor:pointer;
    &.active{
        
    }
    .icon{
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }
`;
export const WalletBox = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 8px;
    border-radius: 8px;
    background: #EEEFEF;
    color: #000;
    font-size: 12px;
    font-weight: 700;
    box-sizing: border-box;
    cursor:pointer;
    margin-bottom: 16px;
    .icon{
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }
`;

export const IPWarn = styled.div`

`;

export const LiTitle = styled.h3`
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    margin-bottom: 8px;
`;
